<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            <v-row >
              <v-col>
                Notification
              </v-col>
              <v-col lg="6">
                <v-select
                  v-model="select"
                  :items="notificationsRole"
                  label="Pick Notification"
                  multiple
                  chips
                  dense
                  class="float-right"
                  @change="getData(page,itemsPerPage)"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
          <span v-for="item in notif" :key="item.key">
            <span v-if="item.notif==notifications[0].value">
              <v-alert
                type="error"
                color="error darken-3"
              >
                {{item.text}}
              </v-alert>
            </span>
            <span v-if="item.notif==notifications[1].value">
              <v-alert
                type="error"
                color="orange darken-3"
              >
                {{item.text}}
              </v-alert>
            </span>
            <span v-if="item.notif==notifications[2].value">
              <v-alert
                type="info"
                color="purple darken-3"
              >
                {{item.text}}
              </v-alert>
            </span>
            <span v-if="item.notif==notifications[3].value">
              <v-alert
                type="info"
              >
                {{item.text}}
              </v-alert>
            </span>
            <span v-if="item.notif==notifications[4].value">
              <v-alert
                type="success"
              >
                {{item.text}}
              </v-alert>
            </span>
          </span>
          <span v-if="noData">
            <div class="text-center subtitle-1">No Notification(s) Data</div>
          </span>
          <v-row>
            <v-col> 
              <span v-if="noData">
                <v-btn disabled icon class="float-right mx-2" color="#757575" @click="page++;getData(page,itemsPerPage)">
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </span>
              <span v-else>
                <v-btn icon class="float-right mx-2" color="#757575" @click="page++;getData(page,itemsPerPage)">
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </span>
              <body-1 class="float-right mt-2 mx-2">
                {{page}}
              </body-1>
              <span v-if="page==1">
                <v-btn disabled icon class="float-right mx-2" color="#757575" @click="page--;getData(page,itemsPerPage)">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </span>
              <span v-else>
                <v-btn icon class="float-right mx-2" color="#757575" @click="page--;getData(page,itemsPerPage)">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </span>
            </v-col>
          </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import firebase from "firebase/app"
import { db }from "@/firebase/db.js"
import moment from 'moment'

  export default {
    name: 'Notification',
    data: () => ({
      notificationsRole:[],
      notifications:[{
          text: 'Bahaya',
          value:'bahaya'
        },
        {
          text: 'Evakuasi',
          value:'evakuasi'
        },
        {
          text: 'Waspada',
          value: 'waspada'
        },  
        {
          text: 'Low Battery',
          value: 'battery'
        }, 
        {
          text: 'Device On',
          value: 'turnedOn'
        }],
      select: [],
      condition:[],
      notif:[],
      devices:[],
      offset:0,

      bahayaNotif:'',
      bahayaNotifArray:{
        station:[],
        time:[],
        tinggi:[],
        text:[],
      },
      evakuasiNotif:'',
      evakuasiNotifArray:{
        station:[],
        time:[],
        tinggi:[],
        text:[],
      },
      waspadaNotif:'',
      waspadaNotifArray:{
        station:[],
        time:[],
        tinggi:[],
        text:[],
      },
      batteryNotif:'',
      batteryNotifArray:{
        station:[],
        time:[],
        text:[],
      },
      turnedOnNotif:'',
      turnedOnNotifArray:{
        station:[],
        time:[],
        text:[],
      },
      lastData:{},
      beforeData:[],
      firstData:{},
      lastPage:1,
      page:1,
      itemsPerPage:20,
      noData:true,
      locations: ['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE']
    }),
    async mounted () {
      let loader = this.$loading.show()
      if (localStorage.getItem("role")=='Petugas') {
        let device = localStorage.getItem('device')
        this.$router.push(`/MapPetugas-id=${device}&device=${localStorage.getItem('jenis')}`)
      }
      const date=new Date();
      this.offset=date.getTimezoneOffset()/(-60)
      db.collection('notificationSetRadar').onSnapshot((collectionSnapshot) => {
        collectionSnapshot.forEach((doc) => {
          if (doc.id=='bahaya') {
            this.bahayaNotifArray=doc.data()
          }
          if (doc.id=='evakuasi') {
            this.evakuasiNotifArray=doc.data()
          }
          if (doc.id=='waspada') {
            this.waspadaNotifArray=doc.data()
          }
          if (doc.id=='turnedOn') {
            this.turnedOnNotifArray=doc.data()
          }
          if (doc.id=='battery') {
            this.batteryNotifArray=doc.data()
          }
        })
        loader.hide()
      })
       
      let setByLocation=false

      let role=localStorage.getItem("role");
      await db.collection('roleNotification').doc(role).get().then((doc)=> {
        setByLocation=doc.data().location
        for(let i=0;i<doc.data().radar.length;i++) {
          this.notificationsRole.push({value:doc.data().radar[i], text:this.valToText(doc.data().radar[i])})
          this.select.push(doc.data().radar[i])
        }
      })
      
      let location=localStorage.getItem("location");
      if (setByLocation) {
        db.collection('radar').where('location','==', location).onSnapshot((collectionSnapshot) => {
          this.devices=[]
          collectionSnapshot.forEach((doc) => {
            this.devices.push({id:doc.id, ...doc.data()})
          });
        }) 
      } else {
        db.collection('radar').onSnapshot((collectionSnapshot) => {
          this.devices=[]
          collectionSnapshot.forEach((doc) => {
            this.devices.push({id:doc.id, ...doc.data()})
          });
        }) 
      }
      await this.getData(this.page,this.itemsPerPage, setByLocation, location)
    },
    methods: {
      valToText(val){
        let i=this.notifications.findIndex(x=>x.value === val)
        return this.notifications[i].text
      },
      textConstructor(format,station,time,tinggi,satuan) {
        let text=''
        let text_length=0
        if (typeof format.text !== 'undefined') {
          text_length += format.text.length
        }
        if (typeof format.station !== 'undefined') {
          text_length += format.station.length
        }
        if (typeof format.time !== 'undefined') {
          text_length += format.time.length
        }
        if (typeof format.tinggi !== 'undefined') {
          text_length += format.tinggi.length
        }
        if (typeof format.satuan !== 'undefined') {
          text_length += format.satuan.length
        }

        let textArray=[]
        for (let i=0; i<text_length; i++) {
          let j=0;
          let k=0;
          let l=0;
          let m=0;
          if (typeof format.station !== 'undefined') {
            if (i == format.station[j]) {
              textArray.push(station)
              j++;
            }
          }
          if (typeof format.time !== 'undefined') {
            if (i == format.time[k]) {
              textArray.push(this.updateTime(time))
              k++;
            }
          }
          if (tinggi!=-1) {
            if (typeof format.tinggi !== 'undefined') {
              if (i == format.tinggi[l]) {
                textArray.push(tinggi)
                l++;
              }
            }
          }

          if (satuan!=-1) {
            if (typeof format.satuan !== 'undefined') {
              if (i == format.satuan[m]) {
                textArray.push(satuan)
                m++;
              }
            }
          }
          textArray.push(format.text[i])
          if (textArray[i]!= undefined) {
            text= text.concat(textArray[i])
          }
          
        }
        return text
      },
      updateTime (time) {
        return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
      },
      async getData (page,items, setLocation, location) {
        let loader=this.$loading.show()
        if (this.select.length<1) {
          this.notif=[]
          loader.hide()
          return
        }
        var dataRef = db.collection('radarNotif').orderBy("timestamp","desc").where('notif','in',this.select).limit(items)
        if (localStorage.getItem('location')!='MARNOV') {
          dataRef = db.collection('radarNotif').orderBy("timestamp","desc").where('notif','in',this.select).orderBy('location','desc').limit(items)
        }
        if (setLocation) {
          dataRef = db.collection('radarNotif').orderBy("timestamp","desc").where('notif','in',this.select).where('location','==',location).limit(items)
        } 
        //forward
        if (page>this.lastPage && (page!=1)) {
          this.beforeData.push(this.firstData)
          this.beforeData[page-1]=this.firstData
          this.lastPage=page
          dataRef = db.collection('radarNotif').orderBy("timestamp","desc").startAfter(this.lastData).where('notif','in',this.select).limit(items)
          if (localStorage.getItem('location')!='MARNOV') {
            dataRef = db.collection('radarNotif').orderBy("timestamp","desc").orderBy('location','desc').startAfter(this.lastData).where('notif','in',this.select).limit(items)
          }
          if (setLocation) {
            dataRef = db.collection('radarNotif').orderBy("timestamp","desc").startAfter(this.lastData).where('notif','in',this.select).where('location','==',location).limit(items)
          } 
        } 
        // First Page
        else if (page==1) {
          this.lastPage=page
          dataRef = db.collection('radarNotif').orderBy("timestamp","desc").where('notif','in',this.select).limit(items)
          if (localStorage.getItem('location')!='MARNOV') {
            dataRef = db.collection('radarNotif').orderBy("timestamp","desc").where('notif','in',this.select).limit(items).orderBy('location','desc')
          }
          if (setLocation) {
            dataRef = db.collection('radarNotif').orderBy("timestamp","desc").where('notif','in',this.select).where('location','==',location).limit(items)
          }  
        } 
        //backward
        else if (page<this.lastPage) {
          this.lastPage=page
          dataRef = db.collection('radarNotif').orderBy("timestamp","desc").where('notif','in',this.select).limit(items).startAt(this.beforeData[page])
          if (localStorage.getItem('location')!='MARNOV') {
            dataRef = db.collection('radarNotif').orderBy("timestamp","desc").orderBy('location','desc').where('notif','in',this.select).limit(items).startAt(this.beforeData[page])
          }
          if (setLocation) {
            dataRef = db.collection('radarNotif').orderBy("timestamp","desc").where('notif','in',this.select).where('location','==',location).limit(items).startAt(this.beforeData[page])
          }
        }
        dataRef.onSnapshot((collectionSnapshot) => {
          this.notif=[]
          let index=0
          let count=0;
          collectionSnapshot.forEach((doc) => {
            if (count==0) {
              this.firstData=doc
              count++
            }
            index = this.devices.findIndex(x => x.id === doc.data().id);
            if (index!=-1) {
              this.notif.push(doc.data())
            }
            this.lastData=doc;
          });
          if (this.notif.length<1) {
            this.noData=true
          } else {
            this.noData=false
          }
          for (let i=0;i<this.notif.length;i++) {
            this.notif[i].key=i;
            for (let j=0;j<this.devices.length;j++) {
              if (this.notif[i].id==this.devices[j].id) {
                this.notif[i].location=this.devices[j].location
                this.notif[i].station=this.devices[j].station
                this.notif[i].satuan = this.devices[j].satuan
                break;
              }
            }
            if (this.notif[i].notif=='bahaya') {
              this.notif[i].text=this.textConstructor(this.bahayaNotifArray,this.notif[i].station,this.notif[i].timestamp,this.notif[i].satuan=='cm'?Math.round(this.notif[i].ketinggian*100):this.notif[i].ketinggian, this.notif[i].satuan)
            }
            else if (this.notif[i].notif=='waspada') {
              this.notif[i].text=this.textConstructor(this.waspadaNotifArray,this.notif[i].station,this.notif[i].timestamp,this.notif[i].satuan=='cm'?Math.round(this.notif[i].ketinggian*100):this.notif[i].ketinggian, this.notif[i].satuan)
            }
            else if (this.notif[i].notif=='evakuasi') {                
              this.notif[i].text=this.textConstructor(this.evakuasiNotifArray,this.notif[i].station,this.notif[i].timestamp,this.notif[i].satuan=='cm'?Math.round(this.notif[i].ketinggian*100):this.notif[i].ketinggian, this.notif[i].satuan)
            }
            else if (this.notif[i].notif=='turnedOn') {
              this.notif[i].text=this.textConstructor(this.turnedOnNotifArray,this.notif[i].station,this.notif[i].timestamp,-1,-1)
            }
            else {
              this.notif[i].text=this.textConstructor(this.batteryNotifArray,this.notif[i].station,this.notif[i].timestamp,-1,-1)
            }
          }
          loader.hide()
        })
      },
    },
    computed: {
      dateRangeText () {
        return this.dates.join(' ~ ')
      }
    },
    beforeDestroy() {
        console.log('beforeDestroy');
    },
  }
</script>